import { useDispatch } from 'react-redux'

import { parse as parseQuery } from 'query-string'
import { useMemo } from 'react'
import { useTypedSelector } from 'builder/hooks/useTypedSelector'
import { actions as uiActions, selectors as uiSelectors } from 'builder/modules/ui'
import { useFeaturesConfig } from 'builder/hooks/featureConfig/useFeaturesConfig'

const MODAL_SHOWN_STORAGE_KEY = 'rd-auto-apply-dual-modal'

export const useAutoApplyResumeDistributionModal = () => {
  const dispatch = useDispatch()
  const payload = useTypedSelector(uiSelectors.isAutoApplyResumeDistributionModalPayload)
  const { features } = useFeaturesConfig()
  const isInSupportedRegion = ['US', 'GB'].includes(features.geoipCode || '')

  const closeModal = () => {
    localStorage.setItem(MODAL_SHOWN_STORAGE_KEY, 'true')
    dispatch(uiActions.toggleAutoApplyResumeDistributionModal({ open: false }))
  }

  const downloadDocumentId = useMemo(() => {
    const params = parseQuery(window.location.search, { parseNumbers: true })
    return params.download_document_id
  }, [])

  return {
    shouldShowModal: !!downloadDocumentId,
    isOpen: payload.open,
    label: payload.label,
    planName: '20_credits_autoapply',
    isInSupportedRegion,
    closeModal,
  }
}
